import { Box, Button, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import { normalizeAndFormatPhoneNumber } from 'modules/core/lib/phoneNumber'

interface EmployeeLegalEntity {
  country: string
}

interface WhatsAppEmployeeData {
  phoneNumber?: string | null
  country?: string | null
  fullName: string
  legalEntity?: EmployeeLegalEntity | null
}

interface Props {
  employee: WhatsAppEmployeeData
  canSeePersonalInfo: boolean
  hasWhatsappFeature: boolean
}

export const WhatsAppButton = ({ employee, canSeePersonalInfo, hasWhatsappFeature }: Props) => {
  const [open, toggle] = useToggle(false)

  const onClickOpenWhatsappChat = () => {
    track(trackingEvents.comms.openWhatsappChatWithEmployee)
  }

  const phoneNumberFormatted = normalizeAndFormatPhoneNumber({
    phoneNumber: employee.phoneNumber,
    country: employee.country ?? employee.legalEntity?.country,
  })
  const hasWhatsappUrl = phoneNumberFormatted !== null
  const whatsappUrl = phoneNumberFormatted ? `https://wa.me/${phoneNumberFormatted}` : ''

  const renderButton = canSeePersonalInfo && hasWhatsappFeature && hasWhatsappUrl

  useEffect(() => {
    renderButton &&
      track(trackingEvents.comms.whatsappChatWithEmployeeShown, { disabled: !hasWhatsappUrl })
  }, [renderButton, hasWhatsappUrl])

  if (!renderButton) {
    return <></>
  }

  const showTooltip = open && !hasWhatsappUrl

  return (
    <Box flexDirection="row" paddingY="s4" paddingX="s4">
      <Tooltip.Alt
        open={showTooltip}
        toggle={toggle}
        attachment="top center"
        label={i18n.t('common.chat_on_whatsapp.phone_not_available', {
          employee_name: employee.fullName,
        })}
        textAlign="center"
      >
        <Button.Router
          blankTarget
          disabled={!hasWhatsappUrl}
          type="secondary"
          to={whatsappUrl}
          onClick={onClickOpenWhatsappChat}
          iconName="whatsapp-chat"
        >
          {i18n.t('common.chat_on_whatsapp.call_to_action')}
        </Button.Router>
      </Tooltip.Alt>
    </Box>
  )
}
